import { cn } from "@/lib/utils"
import { TestimonialCard, TestimonialAuthor } from "@/components/ui/testimonial-card"

interface TestimonialsSectionProps {
  title: string
  description: string
  testimonials: Array<{
    author: TestimonialAuthor
    text: string
    href?: string
  }>
  className?: string
}

export function TestimonialsSection({ 
  title,
  description,
  testimonials,
  className 
}: TestimonialsSectionProps) {
  return (
    <section className={cn(
      "bg-[#0f141c] text-white",
      "py-8 sm:py-16 md:py-24 lg:py-32 px-0",
      className
    )}>
      <div className="mx-auto flex max-w-container flex-col items-center gap-6 sm:gap-12 text-center">
        <div className="flex flex-col items-center gap-3 sm:gap-6 px-4">
          <h2 className="max-w-[720px] text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-semibold leading-tight text-white">
            {title}
          </h2>
          <p className="text-sm sm:text-lg lg:text-xl max-w-[600px] font-medium text-slate-400">
            {description}
          </p>
        </div>

        <div className="relative flex w-full flex-col items-center justify-center overflow-hidden">
          {/* Container do marquee infinito */}
          <div className="flex overflow-hidden p-2 [--gap:1rem] w-full">
            {/* Wrapper com animação marquee */}
            <div className="flex shrink-0 [gap:var(--gap)] animate-marquee flex-row group-hover:[animation-play-state:paused] [--duration:45s]">
              {/* Primeiro conjunto de depoimentos */}
              <div className="flex shrink-0 [gap:var(--gap)] flex-row">
                {testimonials.map((testimonial, i) => (
                  <TestimonialCard 
                    key={`set1-${i}`}
                    {...testimonial}
                  />
                ))}
              </div>
              
              {/* Segundo conjunto de depoimentos (para continuidade infinita) */}
              <div className="flex shrink-0 [gap:var(--gap)] flex-row ml-[var(--gap)]">
                {testimonials.map((testimonial, i) => (
                  <TestimonialCard 
                    key={`set2-${i}`}
                    {...testimonial}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Gradient overlays para efeito fade nas bordas */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-24 lg:w-32 bg-gradient-to-r from-[#0f141c] via-[#0f141c]/90 to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-24 lg:w-32 bg-gradient-to-l from-[#0f141c] via-[#0f141c]/90 to-transparent z-10" />
        </div>
      </div>
    </section>
  )
} 